
import DefaultController from '../../controller';

import {extend} from '../../functions';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'textinput';
    }  
    
}


let Blueprint = {
    type: Controller,
    properties: { 
        style: {
        },
        attributes: {
            'type': 'text'
        }
      },
    events: {   },
    children: []
}

export default Blueprint;
export {Blueprint, Controller};
